export const data: ModelAPI.Reporting.ReportingResults = {
  'currencyDenomination': 'AUD $M',
  'gameName': 'Erik\'s First Branding Theme',
  'logo': 'https://test-images.banksim.co/api/branding/e51cb2747d7c4d766aa62edc5a1f2548.png',
  'teams': [
    {
      'teamName': 'Team 1',
      'isCpuTeam': false,
      'teamId': 1
    },
    {
      'teamName': 'Team 2',
      'isCpuTeam': false,
      'teamId': 2
    },
    {
      'teamName': 'Team 3',
      'isCpuTeam': false,
      'teamId': 3
    },
    {
      'teamName': 'Team 4',
      'isCpuTeam': false,
      'teamId': 4
    },
    {
      'teamName': 'Team 5',
      'isCpuTeam': false,
      'teamId': 5
    },
    {
      'teamName': 'Team 6',
      'isCpuTeam': false,
      'teamId': 6
    },
    {
      'teamName': 'PC Bank 1',
      'isCpuTeam': true,
      'teamId': 7
    },
    {
      'teamName': 'PC Bank 2',
      'isCpuTeam': true,
      'teamId': 8
    },
    {
      'teamName': 'PC Bank 3',
      'isCpuTeam': true,
      'teamId': 9
    }
  ],
  'customerSatisfaction': {
    'data': [
      {
        'team3': 0,
        'team4': 0,
        'team1': 0,
        'team2': 0,
        'name': 'Round 0',
        'team7': 0,
        'team8': 0,
        'team5': 0,
        'team6': 0,
        'team9': 0
      },
      {
        'team3': 4,
        'team4': 11,
        'team1': 5,
        'team2': 3,
        'name': 'Round 1',
        'team7': 14,
        'team8': 9,
        'team5': -1,
        'team6': 0,
        'team9': 11
      },
      {
        'team3': 8,
        'team4': 25,
        'team1': 21,
        'team2': -1,
        'name': 'Round 2',
        'team7': 34,
        'team8': 8,
        'team5': 2,
        'team6': 4,
        'team9': 23
      },
      {
        'team3': 15,
        'team4': 52,
        'team1': 32,
        'team2': 6,
        'name': 'Round 3',
        'team7': 43,
        'team8': 16,
        'team5': 7,
        'team6': 3,
        'team9': 42
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 4',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 5',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 6',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      }
    ],
    'teamPositions': [
      {
        'teamId': 4,
        'position': 1
      },
      {
        'teamId': 7,
        'position': 2
      },
      {
        'teamId': 9,
        'position': 3
      }
    ]
  },
  'shareholderReturn': {
    'data': [
      {
        'team3': 0.0999999791358203,
        'team4': 0.0999999791358203,
        'team1': 0.0999999791358203,
        'team2': 0.0999999791358203,
        'name': 'Round 0',
        'team7': 0.0999999791358203,
        'team8': 0.0999999791358203,
        'team5': 0.0999999791358203,
        'team6': 0.0999999791358203,
        'team9': 0.0999999791358203
      },
      {
        'team3': 0.061442385393915284,
        'team4': 0.10886664441241566,
        'team1': 0.05692282021199073,
        'team2': 0.04138848860007165,
        'name': 'Round 1',
        'team7': 0.11502456243560685,
        'team8': 0.08707019966872423,
        'team5': 0.0843168059004994,
        'team6': 0.10428231795767964,
        'team9': 0.10540770676925564
      },
      {
        'team3': -0.20878830146795369,
        'team4': 0.12047031191836856,
        'team1': 0.02504672737980367,
        'team2': 0.05184772833112028,
        'name': 'Round 2',
        'team7': 0.11786682318723986,
        'team8': 0.08604387828587659,
        'team5': 0.041116392204470435,
        'team6': 0.13155632793625407,
        'team9': 0.1203548964492906
      },
      {
        'team3': -0.17674111630794853,
        'team4': 0.10406563030305147,
        'team1': 0.07499564522956156,
        'team2': -0.047786809293203183,
        'name': 'Round 3',
        'team7': 0.11499354690498552,
        'team8': 0.08478906394299734,
        'team5': 0.04230795484318103,
        'team6': 0.12371985700665598,
        'team9': 0.10265139193380701
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 4',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 5',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 6',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      }
    ],
    'teamPositions': [
      {
        'teamId': 6,
        'position': 1
      },
      {
        'teamId': 7,
        'position': 2
      },
      {
        'teamId': 4,
        'position': 3
      }
    ]
  },
  'loanImpairmentExpense': {
    'data': [
      {
        'team3': 0.002161287283143015,
        'team4': 0.002161287283143015,
        'team1': 0.002161287283143015,
        'team2': 0.002161287283143015,
        'name': 'Round 0',
        'team7': 0.002161287283143015,
        'team8': 0.002161287283143015,
        'team5': 0.002161287283143015,
        'team6': 0.002161287283143015,
        'team9': 0.002161287283143015
      },
      {
        'team3': 0.0017010233973282346,
        'team4': 0.001943967151432109,
        'team1': 0.0018572079941608494,
        'team2': 0.0020135348707704796,
        'name': 'Round 1',
        'team7': 0.002092349239618794,
        'team8': 0.001882700334517338,
        'team5': 0.0017604846091835056,
        'team6': 0.001964965111904542,
        'team9': 0.0018539977482089213
      },
      {
        'team3': 0.0016276779215117563,
        'team4': 0.0023590581630143453,
        'team1': 0.002033794022776397,
        'team2': 0.0026039501755282554,
        'name': 'Round 2',
        'team7': 0.0026299960625387887,
        'team8': 0.002153685948019996,
        'team5': 0.002007988662552576,
        'team6': 0.002432165121027442,
        'team9': 0.0020475932139895694
      },
      {
        'team3': 0.003957756980326632,
        'team4': 0.006316032516627596,
        'team1': 0.005151092083383595,
        'team2': 0.007471610074879242,
        'name': 'Round 3',
        'team7': 0.006767478646986243,
        'team8': 0.0057336685064893434,
        'team5': 0.006235532082963178,
        'team6': 0.006671479158291141,
        'team9': 0.0055294524204702695
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 4',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 5',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 6',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      }
    ],
    'teamPositions': [
      {
        'teamId': 3,
        'position': 1
      },
      {
        'teamId': 1,
        'position': 2
      },
      {
        'teamId': 9,
        'position': 3
      }
    ]
  },
  'riskIncidents': {
    'data': [
      {
        'team3': 750,
        'team4': 750,
        'team1': 750,
        'team2': 750,
        'name': 'Round 0',
        'team5': 750,
        'team6': 750
      },
      {
        'team3': 662,
        'team4': 590,
        'team1': 601,
        'team2': 800,
        'name': 'Round 1',
        'team5': 818,
        'team6': 737
      },
      {
        'team3': 553,
        'team4': 543,
        'team1': 594,
        'team2': 978,
        'name': 'Round 2',
        'team5': 875,
        'team6': 706
      },
      {
        'team3': 714,
        'team4': 462,
        'team1': 603,
        'team2': 1086,
        'name': 'Round 3',
        'team5': 875,
        'team6': 352
      }
    ],
    'teamPositions': [
      {
        'teamId': 6,
        'position': 1
      },
      {
        'teamId': 4,
        'position': 2
      },
      {
        'teamId': 1,
        'position': 3
      }
    ]
  },
  'returnOnEquity': {
    'data': [
      {
        'team3': 0.20533232460243234,
        'team4': 0.20533232460243234,
        'team1': 0.20533232460243234,
        'team2': 0.20533232460243234,
        'name': 'Round 0',
        'team7': 0.20533232460243234,
        'team8': 0.20533232460243234,
        'team5': 0.20533232460243234,
        'team6': 0.20533232460243234,
        'team9': 0.20533232460243234
      },
      {
        'team3': 0.10868082945274424,
        'team4': 0.18556474904244863,
        'team1': 0.15698503752938753,
        'team2': 0.1656470554044374,
        'name': 'Round 1',
        'team7': 0.2986389090376955,
        'team8': 0.18986711362093642,
        'team5': 0.1630050000285919,
        'team6': 0.20102550042165016,
        'team9': 0.1525212976728068
      },
      {
        'team3': -0.0700328749640479,
        'team4': 0.18585142234931382,
        'team1': 0.10527970509985318,
        'team2': 0.13341362809794713,
        'name': 'Round 2',
        'team7': 0.15619390102036856,
        'team8': 0.1966117526735383,
        'team5': 0.07924044247103627,
        'team6': 0.2137690404417211,
        'team9': 0.1293339706280162
      },
      {
        'team3': -0.2979266658173935,
        'team4': 0.13235758144450316,
        'team1': 0.11327393873340726,
        'team2': -0.19307299940068676,
        'name': 'Round 3',
        'team7': 0.15334873457432904,
        'team8': 0.1536330752273313,
        'team5': -0.02204976401830157,
        'team6': 0.25362984925336757,
        'team9': 0.07271572304180941
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 4',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 5',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 6',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      }
    ],
    'teamPositions': [
      {
        'teamId': 6,
        'position': 1
      },
      {
        'teamId': 8,
        'position': 2
      },
      {
        'teamId': 7,
        'position': 3
      }
    ]
  },
  'customers': {
    'data': [
      {
        'team3': 3293500,
        'team4': 3293500,
        'team1': 3293500,
        'team2': 3293500,
        'name': 'Round 0',
        'team7': 3293500,
        'team8': 3293500,
        'team5': 3293500,
        'team6': 3293500,
        'team9': 3293500
      },
      {
        'team3': 3305597,
        'team4': 3372696,
        'team1': 3281987,
        'team2': 3520186,
        'name': 'Round 1',
        'team7': 3114884,
        'team8': 3191173,
        'team5': 3360221,
        'team6': 3496090,
        'team9': 3311148
      },
      {
        'team3': 3342252,
        'team4': 3412619,
        'team1': 3309538,
        'team2': 3662472,
        'name': 'Round 2',
        'team7': 3125047,
        'team8': 3063462,
        'team5': 3245287,
        'team6': 3622009,
        'team9': 3438966
      },
      {
        'team3': 3056412,
        'team4': 3292810,
        'team1': 2958645,
        'team2': 3772997,
        'name': 'Round 3',
        'team7': 2930277,
        'team8': 2752409,
        'team5': 2917984,
        'team6': 3528527,
        'team9': 3360504
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 4',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 5',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 6',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      }
    ],
    'teamPositions': [
      {
        'teamId': 2,
        'position': 1
      },
      {
        'teamId': 6,
        'position': 2
      },
      {
        'teamId': 9,
        'position': 3
      }
    ]
  },
  'employeeEngagement': {
    'data': [
      {
        'team3': 0.5,
        'team4': 0.5,
        'team1': 0.5,
        'team2': 0.5,
        'name': 'Round 0',
        'team5': 0.5,
        'team6': 0.5
      },
      {
        'team3': 0.524093513557728,
        'team4': 0.6503643660511762,
        'team1': 0.4908501117306018,
        'team2': 0.40656107432888966,
        'name': 'Round 1',
        'team5': 0.6109232662008677,
        'team6': 0.5966236571616552
      },
      {
        'team3': 0.4903740618518785,
        'team4': 0.726006558471431,
        'team1': 0.4395814493140796,
        'team2': 0.4047535306560446,
        'name': 'Round 2',
        'team5': 0.6302151504034702,
        'team6': 0.6643408316915216
      },
      {
        'team3': 0.34693467129859135,
        'team4': 0.749199014798586,
        'team1': 0.6638411935118974,
        'team2': 0.48562213103889973,
        'name': 'Round 3',
        'team5': 0.8023267449316717,
        'team6': 0.7053435536165934
      }
    ],
    'teamPositions': [
      {
        'teamId': 5,
        'position': 1
      },
      {
        'teamId': 4,
        'position': 2
      },
      {
        'teamId': 6,
        'position': 3
      }
    ]
  },
  'reputationIndex': {
    'data': [
      {
        'team3': 0.5,
        'team4': 0.5,
        'team1': 0.5,
        'team2': 0.5,
        'name': 'Round 0',
        'team7': 0.5,
        'team8': 0.5,
        'team5': 0.5,
        'team6': 0.5,
        'team9': 0.5
      },
      {
        'team3': 0.55,
        'team4': 0.47500000000000003,
        'team1': 0.47500000000000003,
        'team2': 0.55,
        'name': 'Round 1',
        'team7': 0.45,
        'team8': 0.55,
        'team5': 0.55,
        'team6': 0.55,
        'team9': 0.55
      },
      {
        'team3': 0.525,
        'team4': 0.525,
        'team1': 0.5,
        'team2': 0.45,
        'name': 'Round 2',
        'team7': 0.45,
        'team8': 0.5,
        'team5': 0.525,
        'team6': 0.55,
        'team9': 0.55
      },
      {
        'team3': 0.555,
        'team4': 0.535,
        'team1': 0.48500000000000004,
        'team2': 0.185,
        'name': 'Round 3',
        'team7': 0.505,
        'team8': 0.53,
        'team5': 0.46,
        'team6': 0.585,
        'team9': 0.625
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 4',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 5',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 6',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      }
    ],
    'teamPositions': [
      {
        'teamId': 9,
        'position': 1
      },
      {
        'teamId': 6,
        'position': 2
      },
      {
        'teamId': 3,
        'position': 3
      }
    ]
  },
  'customerComplaints': {
    'data': [
      {
        'team3': 700,
        'team4': 700,
        'team1': 700,
        'team2': 700,
        'name': 'Round 0',
        'team7': 700,
        'team8': 700,
        'team5': 700,
        'team6': 700,
        'team9': 700
      },
      {
        'team3': 698,
        'team4': 670,
        'team1': 708,
        'team2': 761,
        'name': 'Round 1',
        'team7': 674,
        'team8': 682,
        'team5': 850,
        'team6': 802,
        'team9': 621
      },
      {
        'team3': 625,
        'team4': 587,
        'team1': 668,
        'team2': 833,
        'name': 'Round 2',
        'team7': 637,
        'team8': 673,
        'team5': 977,
        'team6': 871,
        'team9': 521
      },
      {
        'team3': 833,
        'team4': 565,
        'team1': 756,
        'team2': 1151,
        'name': 'Round 3',
        'team7': 678,
        'team8': 730,
        'team5': 1145,
        'team6': 1112,
        'team9': 443
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 4',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 5',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 6',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      }
    ],
    'teamPositions': [
      {
        'teamId': 9,
        'position': 1
      },
      {
        'teamId': 4,
        'position': 2
      },
      {
        'teamId': 7,
        'position': 3
      }
    ]
  },
  'regulatorSanctions': {
    'data': [
      {
        'team3': 0,
        'team4': 0,
        'team1': 0,
        'team2': 0,
        'name': 'Round 0',
        'team7': 0,
        'team8': 0,
        'team5': 0,
        'team6': 0,
        'team9': 0
      },
      {
        'team3': 0,
        'team4': 0,
        'team1': 0,
        'team2': 0,
        'name': 'Round 1',
        'team7': 0,
        'team8': 0,
        'team5': 0,
        'team6': 0,
        'team9': 0
      },
      {
        'team3': 0,
        'team4': 0,
        'team1': 0,
        'team2': 0,
        'name': 'Round 2',
        'team7': 0,
        'team8': 0,
        'team5': 0,
        'team6': 0,
        'team9': 0
      },
      {
        'team3': 0,
        'team4': 0,
        'team1': 0,
        'team2': 1,
        'name': 'Round 3',
        'team7': 0,
        'team8': 0,
        'team5': 0,
        'team6': 0,
        'team9': 0
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 4',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 5',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 6',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      }
    ],
    'teamPositions': [
      {
        'teamId': 1,
        'position': 1
      },
      {
        'teamId': 3,
        'position': 1
      },
      {
        'teamId': 4,
        'position': 1
      },
      {
        'teamId': 5,
        'position': 1
      },
      {
        'teamId': 6,
        'position': 1
      },
      {
        'teamId': 7,
        'position': 1
      },
      {
        'teamId': 8,
        'position': 1
      },
      {
        'teamId': 9,
        'position': 1
      }
    ]
  },
  'incrementalFTE': {
    'data': [
      {
        'team3': 0,
        'team4': 0,
        'team1': 0,
        'team2': 0,
        'name': 'Round 0',
        'team5': 0,
        'team6': 0
      },
      {
        'team3': 2210,
        'team4': 1770,
        'team1': 1562,
        'team2': 733,
        'name': 'Round 1',
        'team5': 1466,
        'team6': 580
      },
      {
        'team3': 2168,
        'team4': 1627,
        'team1': 1488,
        'team2': 762,
        'name': 'Round 2',
        'team5': 1391,
        'team6': 556
      },
      {
        'team3': 1138,
        'team4': 1030,
        'team1': 1200,
        'team2': 140,
        'name': 'Round 3',
        'team5': 298,
        'team6': 625
      }
    ],
    'teamPositions': [
      {
        'teamId': 1,
        'position': 1
      },
      {
        'teamId': 3,
        'position': 2
      },
      {
        'teamId': 4,
        'position': 3
      }
    ]
  },
  'incrementalFTECosts': {
    'data': [
      {
        'team3': 0,
        'team4': 0,
        'team1': 0,
        'team2': 0,
        'name': 'Round 0',
        'team5': 0,
        'team6': 0
      },
      {
        'team3': 765,
        'team4': 716,
        'team1': 492,
        'team2': 173,
        'name': 'Round 1',
        'team5': 764,
        'team6': 381
      },
      {
        'team3': 764,
        'team4': 669,
        'team1': 477,
        'team2': 185,
        'name': 'Round 2',
        'team5': 736,
        'team6': 372
      },
      {
        'team3': 271,
        'team4': 434,
        'team1': 650,
        'team2': 73,
        'name': 'Round 3',
        'team5': 277,
        'team6': 645
      }
    ],
    'teamPositions': [
      {
        'teamId': 1,
        'position': 1
      },
      {
        'teamId': 6,
        'position': 2
      },
      {
        'teamId': 4,
        'position': 3
      }
    ]
  },
  'creditRating': {
    'data': [
      {
        'team3': 0.106,
        'team4': 0.106,
        'team1': 0.106,
        'team2': 0.106,
        'name': 'Round 0',
        'team7': 0.106,
        'team8': 0.106,
        'team5': 0.106,
        'team6': 0.106,
        'team9': 0.106
      },
      {
        'team3': 0.11,
        'team4': 0.0976,
        'team1': 0.0912,
        'team2': 0.0959,
        'name': 'Round 1',
        'team7': 0.106,
        'team8': 0.106,
        'team5': 0.11,
        'team6': 0.0926,
        'team9': 0.106
      },
      {
        'team3': 0.0835,
        'team4': 0.0944,
        'team1': 0.0805,
        'team2': 0.0916,
        'name': 'Round 2',
        'team7': 0.106,
        'team8': 0.106,
        'team5': 0.0965,
        'team6': 0.1025,
        'team9': 0.106
      },
      {
        'team3': 0.11,
        'team4': 0.0819,
        'team1': 0.11,
        'team2': 0.11,
        'name': 'Round 3',
        'team7': 0.106,
        'team8': 0.106,
        'team5': 0.11,
        'team6': 0.1003,
        'team9': 0.106
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 4',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 5',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 6',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      }
    ],
    'teamPositions': [
      {
        'teamId': 1,
        'position': 1
      },
      {
        'teamId': 2,
        'position': 1
      },
      {
        'teamId': 3,
        'position': 1
      },
      {
        'teamId': 5,
        'position': 1
      }
    ],
    'creditRatings': {
      'AA': 0.115,
      'BB': 0.085,
      'AAA': 0.125,
      'A': 0.105,
      'B': 0.08,
      'default': -999,
      'BBB': 0.095
    }
  },
  'businessLoanLosses': {
    'data': [
      {
        'team3': 123,
        'team4': 123,
        'team1': 123,
        'team2': 123,
        'name': 'Round 0',
        'team7': 123,
        'team8': 123,
        'team5': 123,
        'team6': 123,
        'team9': 123
      },
      {
        'team3': 123,
        'team4': 123,
        'team1': 122,
        'team2': 133,
        'name': 'Round 1',
        'team7': 126,
        'team8': 126,
        'team5': 148,
        'team6': 123,
        'team9': 130
      },
      {
        'team3': 169,
        'team4': 169,
        'team1': 162,
        'team2': 213,
        'name': 'Round 2',
        'team7': 182,
        'team8': 173,
        'team5': 262,
        'team6': 169,
        'team9': 193
      },
      {
        'team3': 691,
        'team4': 719,
        'team1': 680,
        'team2': 988,
        'name': 'Round 3',
        'team7': 768,
        'team8': 732,
        'team5': 1317,
        'team6': 768,
        'team9': 898
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 4',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 5',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 6',
        'team7': null,
        'team8': null,
        'team5': null,
        'team6': null,
        'team9': null
      }
    ],
    'teamPositions': [
      {
        'teamId': 1,
        'position': 1
      },
      {
        'teamId': 3,
        'position': 2
      },
      {
        'teamId': 4,
        'position': 3
      }
    ]
  },
  'overallWinner': {
    'data': [
      {
        'team3': -1,
        'team4': -1,
        'team1': -1,
        'team2': -1,
        'name': 'Round 0',
        'team5': -1,
        'team6': -1
      },
      {
        'team3': -4,
        'team4': -4,
        'team1': -6.6,
        'team2': -5,
        'name': 'Round 1',
        'team5': -5.2,
        'team6': -4.4
      },
      {
        'team3': -4.6,
        'team4': -2.4,
        'team1': -5.8,
        'team2': -7.6,
        'name': 'Round 2',
        'team5': -6,
        'team6': -3.6
      },
      {
        'team3': -5.4,
        'team4': -2.8,
        'team1': -5.8,
        'team2': -8.6,
        'name': 'Round 3',
        'team5': -7.6,
        'team6': -4.2
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 4',
        'team5': null,
        'team6': null
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 5',
        'team5': null,
        'team6': null
      },
      {
        'team3': null,
        'team4': null,
        'team1': null,
        'team2': null,
        'name': 'Round 6',
        'team5': null,
        'team6': null
      }
    ],
    'teamPositions': [
      {
        'teamId': 4,
        'position': 1
      },
      {
        'teamId': 6,
        'position': 2
      },
      {
        'teamId': 3,
        'position': 3
      }
    ]
  },
  'wholesaleFundingIssues': [
    {
      'value': 176351.3821063496,
      'teamId': 3,
      'percentage': 0.09532049795141431
    },
    {
      'value': 97915,
      'teamId': 2,
      'percentage': 0.08334872606639916
    },
    {
      'value': 95109.1912454728,
      'teamId': 5,
      'percentage': 0.07275711422276773
    },
    {
      'value': 92351,
      'teamId': 4,
      'percentage': 0.0625831587780313
    },
    {
      'value': 51072.77323956466,
      'teamId': 1,
      'percentage': 0.0775492421917086
    },
    {
      'value': 39030,
      'teamId': 6,
      'percentage': 0.06386567442914662
    }
  ],
  'npatAndRoe': [
    {
      'roe': 0.25362984925336757,
      'npat': 3238.129804134837,
      'teamId': 6
    },
    {
      'roe': 0.1536330752273313,
      'npat': 2500.0639854015435,
      'teamId': 8
    },
    {
      'roe': 0.15334873457432904,
      'npat': 2356.2705785239486,
      'teamId': 7
    },
    {
      'roe': 0.11327393873340726,
      'npat': 1742.547812453643,
      'teamId': 1
    },
    {
      'roe': 0.13235758144450316,
      'npat': 1636.3562882604801,
      'teamId': 4
    },
    {
      'roe': 0.07271572304180941,
      'npat': 1375.0773418045296,
      'teamId': 9
    },
    {
      'roe': -0.02204976401830157,
      'npat': -479.96071147641,
      'teamId': 5
    },
    {
      'roe': -0.19307299940068676,
      'npat': -2724.5276319024247,
      'teamId': 2
    },
    {
      'roe': -0.2979266658173935,
      'npat': -6328.379009824577,
      'teamId': 3
    }
  ],
  'marketDebrief': [
    {
      'name': 'HOME LOANS',
      'growth': 0.009975556373345854,
      'type': 'HOME_LOANS',
      'losses': [
        0.0007499999999999999,
        0.0029999999999999996
      ]
    },
    {
      'name': 'BUSINESS LOANS',
      'growth': -0.038894551176130714,
      'type': 'BUSINESS_LOANS',
      'losses': [
        0.00044000000000000007,
        0.064
      ]
    },
    {
      'name': 'DEPOSITS',
      'growth': 0.08000000003862541,
      'type': 'DEPOSITS',
      'losses': null
    },
    {
      'name': 'CREDIT CARDS',
      'growth': -0.1537903631656968,
      'type': 'CREDIT_CARDS',
      'losses': [
        0.037500000000000006
      ]
    }
  ],
  'excoDecision': {
    'name': 'Mortgage Insurance Respond or Research?',
    'options': [
      {
        'name': 'Send For Remediation',
        'description': 'Acknowledge the risk rating and send to the remediation team so they can undertake more comprehensive analysis to assess the extent of the issue. 21 customers seems too low for such a big portfolio.',
        'id': 'e55d3d7b-9157-4f7d-ad54-2640843f5e80',
        'teams': [
          4
        ],
        'outcome': 'To be updated...'
      },
      {
        'name': 'Divert Shared Resources',
        'description': 'Have our business owners revisit and extend the amount of data used to ensure accuracy before making a decision. To enable this, divert shared analytical resources away from analysis which was likely to reduce costs by 20m.',
        'id': 'd38deea1-3510-47f3-b8c8-956ede9f49be',
        'teams': [],
        'outcome': 'To be updated...'
      },
      {
        'name': 'Jump The Queue',
        'description': 'Despite the "low" rating, use pressure to have the remediation team start work on this immediately. This will de-prioritise all other remediation priorities. You are unclear what remediation activities will be deferred as a result.',
        'id': '30420757-a9fa-42e9-9884-c9cf275cc612',
        'teams': [
          2,
          3,
          5,
          6
        ],
        'outcome': 'To be updated...'
      }
    ],
    'description': 'When home loan customers borrow in excess of a 80% Loan-to-Value ratio, they are often required to pay Lender’s Mortgage Insurance (LMI) to safeguard the bank against a default due to the higher leverage and associated risk. If customers repay their loan within 2 years of taking out the loan, they are entitled to a partial refund of their insurance premium. A risk incident has been identified, your leadership team is presented with preliminary analysis suggesting 21 customers have not been paid this refund. The compliance assessment based on the available data rates the issue as low. \nWhat course of action do you recommend:',
    'id': '94db9ae9-6adb-482b-82b4-7b813c27a4d0',
    'type': 'lmi-insurance',
    'imageUrl': 'https://test-images.banksim.co/api/exco/exco-47f76c2dc85e1fb7925d8ed1249652d4.jpg'
  },
  'dealRoom': {
    'imageUrl': 'https://test-images.banksim.co/api/deals/deal-a4f74294be43f718d4615bc8f8230a72.jpg',
    'name': 'Payments Partner',
    'bids': [
      {
        'bid': 666,
        'return': 0.15126466951121947,
        'teamId': 4
      },
      {
        'bid': 567,
        'return': 0.1699418458967206,
        'teamId': 2
      },
      {
        'bid': 520,
        'return': 0.18010869712238436,
        'teamId': 1
      },
      {
        'bid': 455,
        'return': 0.19595089944851984,
        'teamId': 9
      },
      {
        'bid': 400,
        'return': 0.2111248573527059,
        'teamId': 5
      },
      {
        'bid': 343,
        'return': 0.22556775104976248,
        'teamId': 6
      },
      {
        'bid': 303,
        'return': 0.22425807637951947,
        'teamId': 8
      },
      {
        'bid': 275,
        'return': 0.20742359102201874,
        'teamId': 7
      },
      {
        'bid': 0,
        'return': 0,
        'teamId': 3
      }
    ],
    'description': 'You’ve heard about an exciting overseas company making significant advances in payments technology not currently seen in your home market. Dextech is looking to partner with a large bank to provide them with funding and distribution capabilities.&nbsp;<div>Dextech are small but are growing incredibly fast, their future growth is hard to predict. Dextech will require heavy levels of investment so don’t expect any dividends for the next 10 years. Preliminary due diligence has given your transactional banking team a high level of confidence that Dextech’s technology would provide a sustainable advantage in your deposits business, however it has also highlighted significant cultural differences and a lack of maturity in robust internal processes.</div>',
    'id': '0451041e-d381-486b-ae95-a258509719ff',
    'type': 'payments-partner',
    'outcome': '<div>Final due diligence confirms that Dextech looks set to grow at 25% for the next 10 years.  (Within the 20-30% estimate) </div><div>Dextech’s patented technology secures an advantage over competitors.</div><div>Customers value this equal to additional deposit interest of 5bps. </div>'
  },
  'amlEvent': {fine: 300000, teamId: 1},
  'newsRoom': {
    'scenario2Type': 'bull',
    'referenceRate': 'BBSW',
    'scenario1Title': 'Slowly Recovering',
    'scenario1Desc': 'Economy recovering from the down turn. Optimism is creeping back. Unemployment levels decreasing slowly. Debt and equity investors still cautious.',
    'scenario2Desc': 'Deleveraging has occurred, business confidence is starting to pick up, the world needs commodity exports and so Australia will make a comfortable bounce back.',
    'scenario3Desc': 'None of the problems we faced have been dealt with and the bubble like house price gains haven’t returned to normal levels yet. It is often quietest in the eye of the hurricane.',
    'scenario3Type': 'bear',
    'scenario3Title': 'Bear Market View',
    'centralBank': 'rba',
    'cashRate': 0.025,
    'scenario2Title': 'Bull Market View',
    'cashRateDesc': 'The official cash rate has remained unchanged at 0.25%'
  },
  'nextDealRoom': {
    'name': 'Offshore Bank',
    'decide': {
      'prompt': 'You’ll need to decide:',
      'decisions': [
        'the appropriate level of investment return',
        'the expected amount of synergies'
      ]
    },
    'overviewDescription': 'An overseas bank is looking for a foreign partner.\n\n49% stake for sale. ',
    'overviewQuestion': 'Are you ready to expand overseas?',
    'imageUrl': 'https://test-images.banksim.co/api/deals/deal-441659430886fa3c8020624892065524.jpg'
  },
  'bankBailouts': [
    {
      'amount': 44436.77323956466,
      'teamId': 1
    },
    {
      'amount': 123037.3821063496,
      'teamId': 3
    },
    {
      'amount': 47359.1912454728,
      'teamId': 5
    }
  ],
  'royalCommissionEvent': {
    costsPerBank: 2000,
    remediationCosts: 500,
    teams: [1, 2, 4, 6, 5]
  },
  'marketMargins': {
    'data': [
      {
        'name': 'Round 0',
        'margin': 0.02912983247647696,
        'cost': 0.02782390611642897
      },
      {
        'name': 'Round 1',
        'margin': 0.024444366931698883,
        'cost': 0.030603805132773665
      },
      {
        'name': 'Round 2',
        'margin': 0.017085195725535896,
        'cost': 0.036180871363666274
      },
      {
        'name': 'Round 3',
        'margin': 0.012117885759442837,
        'cost': 0.040126690554206666
      }
    ],
    'teams': [
      {
        'margin': 0.0222,
        'teamId': 1,
        'change': 0.0046
      },
      {
        'margin': 0.0024,
        'teamId': 2,
        'change': -0.0133
      },
      {
        'margin': -0.0127,
        'teamId': 3,
        'change': -0.016399999999999998
      },
      {
        'margin': 0.0192,
        'teamId': 4,
        'change': -0.0026000000000000016
      },
      {
        'margin': 0.0098,
        'teamId': 5,
        'change': -0.0087
      },
      {
        'margin': 0.0318,
        'teamId': 6,
        'change': 0.006600000000000002
      }
    ]
  },
  'wsfCostsAllRatings': {
    'data': [
      {
        'AA': 0.030873200000000003,
        'BB': 0.0413208,
        'AAA': 0.028724000000000003,
        'A': 0.0335224,
        'B': 0.045970000000000004,
        'BBB': 0.0371716,
        'name': 'Round 0'
      },
      {
        'AA': 0.030873200000000003,
        'BB': 0.0413208,
        'AAA': 0.028724000000000003,
        'A': 0.0335224,
        'B': 0.045970000000000004,
        'BBB': 0.0371716,
        'name': 'Round 1'
      },
      {
        'AA': 0.034696241644,
        'BB': 0.046025250336,
        'AAA': 0.03218657208,
        'A': 0.037680911208000004,
        'B': 0.0509099199,
        'BBB': 0.041615580772,
        'name': 'Round 2'
      },
      {
        'AA': 0.049113411364,
        'BB': 0.068843058016,
        'AAA': 0.04253686248000001,
        'A': 0.055689960248,
        'B': 0.0754196069,
        'BBB': 0.062266509132000006,
        'name': 'Round 3'
      },
      {
        'AA': 0.04124330646800001,
        'BB': 0.056331930592,
        'AAA': 0.03688043176,
        'A': 0.04585618117600001,
        'B': 0.0619448053,
        'BBB': 0.050969055884000004,
        'name': 'Round 4'
      }
    ]
  },
  'wsfCostsARatings': {
    'data': [
      {
        'name': 'Round 0',
        'wsf1': 0.028052000000000004,
        'wsf5': 0.0387824,
        'wsf4': 0.0358368,
        'wsf3': 0.0335224,
        'wsf2': 0.031418400000000006
      },
      {
        'name': 'Round 1',
        'wsf1': 0.028052000000000004,
        'wsf5': 0.0387824,
        'wsf4': 0.0358368,
        'wsf3': 0.0335224,
        'wsf2': 0.031418400000000006
      },
      {
        'name': 'Round 2',
        'wsf1': 0.031477,
        'wsf5': 0.04405892,
        'wsf4': 0.040394658824,
        'wsf3': 0.037680911208000004,
        'wsf2': 0.035213868112
      },
      {
        'name': 'Round 3',
        'wsf1': 0.046551999999999996,
        'wsf5': 0.06654,
        'wsf4': 0.060001098328,
        'wsf3': 0.055689960248,
        'wsf2': 0.051770744768
      },
      {
        'name': 'Round 4',
        'wsf1': 0.038552,
        'wsf5': 0.053911200000000006,
        'wsf4': 0.04916894811200001,
        'wsf3': 0.04585618117600001,
        'wsf2': 0.04284457238400001
      }
    ]
  },
  'regulatoryCapitalIntervention': [
    {
      'amount': 5958.420804930018,
      'teamId': 1
    },
    {
      'amount': 6655.689567295364,
      'teamId': 2
    },
    {
      'amount': 16197.04179078444,
      'teamId': 3
    },
    {
      'amount': 6852.442259111514,
      'teamId': 5
    }
  ],
  'layouts': [
    {
      'id': 'summary',
      'type': 'summary',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'team_summary',
      'type': 'team_summary',
      'enabled': true,
      'roundRestrictions': [1],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'executive_decisions_table',
      'type': 'executive_decisions_table',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'executive_decisions_table_two',
      'type': 'executive_decisions_table_two',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'market_debrief',
      'type': 'market_debrief',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'net_interest_margin',
      'type': 'net_interest_margin',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'business_loan_losses',
      'type': 'business_loan_losses',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'deal_room_results',
      'type': 'deal_room_results',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'royal_commission',
      'type': 'royal_commission',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'neobank_aml_issue',
      'type': 'neobank_aml_issue',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'risk_incidents_closing',
      'type': 'risk_incidents_closing',
      'enabled': false,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'bank_bail_outs',
      'type': 'bank_bail_outs',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'wholesale_funding_issues',
      'type': 'wholesale_funding_issues',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'regulatory_capital_intervention',
      'type': 'regulatory_capital_intervention',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'npat_&_roe',
      'type': 'npat_&_roe',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'incremental_fte',
      'type': 'incremental_fte',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'incremental_fte_costs',
      'type': 'incremental_fte_costs',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'employee_engagement',
      'type': 'employee_engagement',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'risk_incidents',
      'type': 'risk_incidents',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'customer_complaints',
      'type': 'customer_complaints',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'reputation_index',
      'type': 'reputation_index',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'customer_satisfaction',
      'type': 'customer_satisfaction',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'return_on_equity',
      'type': 'return_on_equity',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'customers',
      'type': 'customers',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'loan_impairment_expense',
      'type': 'loan_impairment_expense',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'credit_rating',
      'type': 'credit_rating',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'regulator_sanctions',
      'type': 'regulator_sanctions',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'total_shareholder_return',
      'type': 'total_shareholder_return',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'overall_winning_metric',
      'type': 'overall_winning_metric',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'deal_room_information',
      'type': 'deal_room_information',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'news_room',
      'type': 'news_room',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'wholesale_funding_costs_all_ratings',
      'type': 'wholesale_funding_costs_all_ratings',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    },
    {
      'id': 'wholesale_funding_costs_a_ratings',
      'type': 'wholesale_funding_costs_a_ratings',
      'enabled': true,
      'roundRestrictions': [],
      'sort': 0,
      'config': {}
    }
  ]
}